import React from 'react';

function Todo({ todo, index, onCheck, onDelete }) {
    const checkboxId = `checkbox-${index}`;
    return (
        <li
            className={`list-group-item d-flex justify-content-between align-items-center list-group-item-action ${todo.checked ? 'list-group-item-secondary ' : ''}`}
        >
            <div>
                <input
                    type="checkbox"
                    className="form-check-input me-3"
                    id={checkboxId}
                    checked={todo.checked}
                    onChange={onCheck}
                />
                <label className="form-check-label stretched-link" htmlFor={checkboxId}>{todo.text}</label>
            </div>
            <div style={{ zIndex: 1 }}>
                <button className="btn btn-sm" onClick={onDelete}>
                    <i className="bi bi-x-lg"></i>
                </button>
            </div>
        </li>
    );
}

export default Todo;
